import { atom, useAtom } from "jotai";

const currentEditHighlightModalAtom = atom<HighlightEditModalType>(null);

const currentViewHighlightModalAtom = atom<HighlightViewModalType>(null);

export type HighlightEditModalType =
    | "editClick"
    | "editFromViewClick"
    | "editFromViewList"
    | null;
export type HighlightViewModalType = "viewClick" | "viewList" | null;

const useActiveHighlightModal = () => {
    const [activeEditHighlightModal, setActiveEditHighlightModal] = useAtom(
        currentEditHighlightModalAtom
    );
    const [activeViewHighlightModal, setActiveViewHighlightModal] = useAtom(
        currentViewHighlightModalAtom
    );

    const setActiveEditModal = (type: HighlightEditModalType) => {
        setActiveEditHighlightModal((prev) => (prev === type ? null : type));
    };
    const closeActiveEditModal = () => {
        setActiveEditHighlightModal(null);
    };

    const setActiveViewModal = (type: HighlightViewModalType) => {
        setActiveViewHighlightModal((prev) => (prev === type ? null : type));
    };
    const closeActiveViewModal = () => {
        setActiveViewHighlightModal(null);
    };

    return {
        activeEditHighlightModal,
        activeViewHighlightModal,
        setActiveEditModal,
        closeActiveEditModal,
        setActiveViewModal,
        closeActiveViewModal,
    };
};

export default useActiveHighlightModal;
